"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

/*
 * Can be used to skip the first render when using the useEffect hook e.g.
 *
 * const isMounted = useIsMounted();
 *
 * useEffect(() => {
 *   if (isMounted) doSomething();
 * }, [...]);
 */
var useIsMounted = function useIsMounted() {
  var isMountRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    isMountRef.current = true;
  }, []);
  return isMountRef.current;
};

var _default = useIsMounted;
exports.default = _default;